var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    {
      tag: "component",
      class: ["linker", { imaged: _vm.img !== null }, _vm.addClass],
      attrs: {
        href: _vm.isLink ? _vm.link : false,
        target: _vm.target,
        download: _vm.download ? _vm.download : false
      },
      on: { click: _vm.clickLink }
    },
    [
      _vm._t("before"),
      _vm.img
        ? _c(
            "div",
            { staticClass: "linker__image" },
            _vm._l(Array.isArray(_vm.img) ? _vm.img : [_vm.img], function(img) {
              return _c("img", { attrs: { src: img } })
            }),
            0
          )
        : _vm._e(),
      _vm.text
        ? _c("span", {
            staticClass: "linker__text",
            domProps: { innerHTML: _vm._s(_vm.nl2br(_vm.text)) }
          })
        : _vm._e(),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }